import styled from 'styled-components';

import { Icon } from '@creditornot/alchemy-react';
import * as icons from '@creditornot/alchemy-react/icons';
import { color } from '@creditornot/cb-ingredients/design-tokens';

type Props = React.ButtonHTMLAttributes<HTMLButtonElement>;

const BG = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  transition: transform 96ms ease-in;
  z-index: 1;
`;

const IconContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  overflow: hidden;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Root = styled.button`
  padding: 0;
  border: none;
  background: none;

  position: relative;
  flex-shrink: 0;
  z-index: 0;

  width: 24px;
  height: 24px;
  border-radius: 50%;

  cursor: pointer;

  svg {
    fill: ${color.textSubdued};
    transition: fill 96ms ease-in;
    width: 12px;
    height: 12px;
  }

  ${BG} {
    background-color: ${color.bg};
  }

  &:hover {
    ${BG} {
      background-color: #ffffffe3;
      transform: scale(1);
    }

    svg {
      fill: ${color.textSubdued};
    }
  }

  &:active ${BG} {
    background-color: #ffffffe0;
  }

  .js-focus-visible &:focus:not(.focus-visible) {
    outline: none;
  }
  .js-focus-visible &.focus-visible {
    outline: none;
    box-shadow: 0 0 0 4px #009de03d;

    ${BG} {
      transform: scale(1);
    }
  }
`;

export const CloseButton = ({ type = 'button', ...rest }: Props) => (
  <Root type={type} {...rest}>
    <BG />
    <IconContainer>
      <Icon source={icons.cross} size="small" />
    </IconContainer>
  </Root>
);
